import type { Editor } from '@tiptap/react';
import type { ReactNode } from 'react';
import { isEditorPristine } from '../utils';

type Props = {
  editor: Editor;
  placeholder: ReactNode;
};

export const Placeholder = ({ editor, placeholder }: Props) => {
  if (!isEditorPristine(editor)) {
    return null;
  }

  return <div className="absolute inset-0">{placeholder}</div>;
};
